import { useState } from 'react';
import { trackWhatsAppConversion } from '../../utils/analytics';

const PHONE = '77471319581';
const WA_URL = `https://wa.me/${PHONE}`;

export default function FloatingWhatsApp() {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
      {hovered && (
        <div className="bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-xl shadow-lg whitespace-nowrap animate-fade-in border border-gray-100">
          Написать в WhatsApp
        </div>
      )}
      <a
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackWhatsAppConversion}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Написать в WhatsApp"
        className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 active:scale-95 transition-transform duration-200 cursor-pointer"
      >
        <i className="ri-whatsapp-line text-white text-3xl leading-none" />
      </a>
    </div>
  );
}
